<footer class="rodape-container" role="contentinfo" aria-label="Rodapé do site">
  <div class="rodape-inner container">
    <div class="bloco-principal">
      <div class="cabecalho">
        <div class="icone-te">
          <b class="sigla">TE</b>
        </div>
        <div class="titulos">
          <div class="titulo-principal">
            <b class="texto-titulo">Transparência</b>
          </div>
          <div class="subtitulo">
            <div class="categoria">Educacional</div>
          </div>
        </div>
      </div>
      <div class="descricao">
        <div class="texto-descricao">Transparência através da informação educacional</div>
      </div>
    </div>

    <div class="rodape-col">
      <h3 class="bloco-titulo">Serviços</h3>
      <ul class="bloco-itens">
        <li><a routerLink="/transparencia/gestao-vagas-matriculas">Vagas e Matrículas</a></li>
        <li><a routerLink="/transparencia/bolsas-auxilios-convenios">Bolsas e Auxílios</a></li>
        <li><a routerLink="/transparencia/estatisticas-educacionais">Estatísticas</a></li>
        <li><a routerLink="/transparencia/receitas-despesas">Receitas e Despesas</a></li>
      </ul>
    </div>

    <div class="rodape-col">
      <h3 class="bloco-titulo">Contato</h3>
      @if (cliente){
      <ul class="bloco-itens" >
        <li class="item-contato">
          <span class="rodape-icon" aria-hidden="true">
            <i-lucide name="phone" size="16" color="#FFFFFFCC"></i-lucide>
          </span>
          <a [href]="`tel:${cliente.telefone}`">{{cliente.telefone | telefone}}</a>
        </li>

        <li class="item-contato">
          <span class="rodape-icon" aria-hidden="true">
            <i-lucide name="mail" size="16" color="#FFFFFFCC"></i-lucide>
          </span>
          <a [href]="`mailto:${cliente.email}`">{{cliente.email}}</a>
        </li>

        <li class="item-contato">
          <span class="rodape-icon" aria-hidden="true">
            <i-lucide name="map-pin" size="16" color="#FFFFFFCC"></i-lucide>
          </span>
          <span>{{cliente.municipio.nome}} - {{cliente.municipio.uf}}</span>
        </li>
      </ul>
      }
    </div>

    <div class="rodape-col">
      <h3 class="bloco-titulo">Informações</h3>
      <ul class="bloco-itens">
        @if (cliente && cliente.clienteConfiguracao && cliente.clienteConfiguracao.sicUrl) {
        <li>
          <a [href]="cliente.clienteConfiguracao.sicUrl" target="_blank" rel="noopener noreferrer">
            E-SIC
          </a>
        </li>
        }

        @if (cliente && cliente.clienteConfiguracao && cliente.clienteConfiguracao.ouvidoriaUrl) {
        <li>
          <a [href]="cliente.clienteConfiguracao.ouvidoriaUrl" target="_blank" rel="noopener noreferrer">
            Ouvidoria
          </a>
        </li>
        }

        @if (cliente && cliente.clienteConfiguracao && cliente.clienteConfiguracao.lgpdUrl) {
        <li>
          <a [href]="cliente.clienteConfiguracao.lgpdUrl" target="_blank" rel="noopener noreferrer">
            LGPD
          </a>
        </li>
        }

        <!-- <li><a routerLink="/acessibilidade">Acessibilidade</a></li> -->
      </ul>
    </div>
  </div>

  <hr class="rodape-separator" />

  <div class="rodape-inferior">
    © 2025 Portal de Transparência Educacional - Todos os direitos reservados
  </div>
</footer>